<template>
  <cms-rich-text-simple v-if="$feature.showTitleHtml && content[name]" :content="data" />
  <span v-else>
    <base-interpolator :content="data">
      <template #timer>
        <cms-countdown v-if="content.countdown" v-bind="content.countdown" />
      </template>
    </base-interpolator>
  </span>
</template>

<script lang="ts" setup>
const { content, fieldName } = defineProps<{
  content: Record<string, any>
  fieldName: string
}>()

const { $feature } = useNuxtApp()

const name = $feature.showTitleHtml ? `${fieldName}Html` : fieldName
const data = (content[name] ?? content[fieldName])
</script>
